import { render, staticRenderFns } from "./kneeLift.vue?vue&type=template&id=6a2db15a&scoped=true&"
import script from "./kneeLift.vue?vue&type=script&lang=js&"
export * from "./kneeLift.vue?vue&type=script&lang=js&"
import style0 from "./kneeLift.vue?vue&type=style&index=0&id=6a2db15a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2db15a",
  null
  
)

export default component.exports